import SearchPanel from './SearchPanel';

export {SearchPanel};



/** WEBPACK FOOTER **
 ** ./src/modules/search/components/index.js
 **/